
const decrypt = (salt: string, encoded: string): string => {
  const textToChars = (text: string): number[] => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code: number): number => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded
    .match(/.{1,2}/g)!
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode) => String.fromCharCode(charCode))
    .join("");
};

export default decrypt